<div class="m-3">
  <form
    class="theme-form"
    [formGroup]="authorizationForm"
    (ngSubmit)="authorize()"
  >
    <p>{{ 'profile.setPassword.inputPassword' | translate }}</p>
    <div class="position-relative">
      <input
        [type]="showCurrentPassword ? 'text' : 'password'"
        id="password"
        formControlName="password"
        class="form-control"
        placeholder="********"
      />
      <i
        class="fa password-icon"
        [ngClass]="showCurrentPassword ? 'fa-eye' : 'fa-eye-slash'"
        (click)="togglePasswordVisibility()"
      ></i>
    </div>

    <div class="form-group mb-0 d-flex mt-2 justify-content-end">
      <button
        class="btn btn-sm btn-danger d-block me-2"
        type="button"
        (click)="cancelForms()"
      >
        {{ 'profile.setPassword.buttons.cancel' | translate }}
      </button>
      <button
        class="btn btn-sm btn-secondary d-block"
        type="submit"
        [disabled]="!authorizationForm.valid"
      >
        {{ 'profile.setPassword.buttons.authorize' | translate }}
      </button>
    </div>
  </form>
</div>
